/* eslint-disable no-underscore-dangle */
/* eslint-disable no-continue */
import React from 'react';
import {
  EventActionAdd,
  EventActionIncrease,
  EventNameProductButtonClick,
  EventNameQuantityChange,
  EventVariableDefault,
  EventVariableVariant,
} from './eventsHelper';
import { select } from 'redux-saga/effects';

export const _getOptions = ({
  options,
  selectedVariantTitle,
  handleVariantChange,
  hasMultipleVariants,
  isPopup,
}) =>
  !isPopup ? (
    <select
      className="mr-select-variant"
      onChange={handleVariantChange}
      value={selectedVariantTitle}
    >
      {options.map((value, i) => (
        <option key={`option${i}`} value={value}>
          {value}
        </option>
      ))}
    </select>
  ) : (
    'selector will come here'
  );

export const _onAddClick = async ({
  product,
  selectedVariant,
  hasMultipleVariants,
  addToCart,
  getProductQuantity,
  productEvent,
}) => {
  // add clicked
  if (hasMultipleVariants) {
    await addToCart(selectedVariant, product.id, product.title);
    const quantity = getProductQuantity();

    productEvent({
      name:
        quantity > 0 ? EventNameQuantityChange : EventNameProductButtonClick,
      action: quantity > 0 ? EventActionIncrease : EventActionAdd,
      variables: [
        {
          name: 'page',
          value: 'offer',
        },
        {
          name: 'type',
          value: EventVariableVariant,
        },
        {
          name: 'sp_product_id',
          value: product.id.toString(),
        },
        {
          name: 'sp_variant_id',
          value: selectedVariant.id.toString(),
        },
      ],
    });

    return;
  }

  const quantity = getProductQuantity();
  productEvent({
    name: quantity > 0 ? EventNameQuantityChange : EventNameProductButtonClick,
    action: quantity > 0 ? EventActionIncrease : EventActionAdd,
    variables: [
      {
        name: 'page',
        value: 'offer',
      },
      {
        name: 'type',
        value: EventVariableDefault,
      },
      {
        name: 'sp_product_id',
        value: product.id.toString(),
      },
      {
        name: 'sp_variant_id',
        value: selectedVariant.id.toString(),
      },
    ],
  });
  // when there is only single variant available
  await addToCart(selectedVariant, product.id, product.title);
};

export const _getReplaceableProduct = ({
  primary,
  products,
  productAdditions,
}) => {
  const result = [];

  for (let i = 0; i < products.length; i++) {
    const { id, variants } = products[i];

    const variantIDs = variants.reduce(
      (items, item) => items.concat(item.id),
      [],
    );
    for (let j = 0; j < productAdditions.length; j++) {
      if (
        productAdditions[j].product_id === id &&
        variantIDs.includes(productAdditions[j].variant_id)
      ) {
        const variantInResult = result.find(
          x =>
            x.sp_product_id === productAdditions[j].product_id &&
            x.sp_variant_id === productAdditions[j].variant_id,
        );

        if (variantInResult !== undefined) {
          result.forEach(x => {
            if (
              x.sp_product_id === productAdditions[j].product_id &&
              x.sp_variant_id === productAdditions[j].variant_id
            ) {
              x.quantity += productAdditions[j].quantity;
            }
          });
        } else {
          result.push({
            sp_product_id: productAdditions[j].product_id,
            sp_variant_id: productAdditions[j].variant_id,
            variant_title: productAdditions[j].variant_title,
            quantity: productAdditions[j].quantity,
          });
        }
      }
    }
  }

  const primaryProductIndex = result.findIndex(
    x =>
      x.sp_product_id === primary.sp_product_id &&
      x.sp_variant_id === primary.sp_variant_id,
  );

  if (primaryProductIndex >= 0) {
    result[primaryProductIndex].quantity -= 1;
  }

  const finalResult = result.filter(x => x.quantity > 0);
  return finalResult;
};

export const _getProductQuantity = ({ productAdditions }) => {
  let quantity = 0;
  for (let i = 0; i < productAdditions.length; i++) {
    quantity += productAdditions[i].quantity;
  }
  return quantity;
};

export const _getProductAddtionsByProductIndex = ({
  idx,
  products,
  productAdditions,
}) => {
  const { id, variants } = products[idx];

  const variantIDs = variants.reduce(
    (items, item) => items.concat(item.id),
    [],
  );
  let variantAdditions = [];
  for (let i = 0; i < productAdditions.length; i++) {
    if (
      productAdditions[i].product_id === id &&
      variantIDs.includes(productAdditions[i].variant_id)
    ) {
      variantAdditions.push(productAdditions[i]);
    }
  }
  return variantAdditions;
};

export const _getLastAddedVariant = (
  product,
  productAdditions,
  getLastAddition,
) => {
  const lastAddition = getLastAddition(productAdditions);
  return product.variants.find(element => {
    return element.id == lastAddition.variant_id;
  });
};

export const _getLastAddition = (productAdditions, getVariantQuantity) => {
  productAdditions.reverse();
  return productAdditions.find(element => {
    return (
      element.quantity > 0 &&
      getVariantQuantity(productAdditions, element.variant_id) > 0
    );
  });
};

export const _getVariantQuantity = (productAdditions, variantid) => {
  // const { productAdditions } = this.props.home;
  let quantity = 0;
  for (let i = 0; i < productAdditions.length; i++) {
    if (productAdditions[i].variant_id === variantid) {
      quantity += productAdditions[i].quantity;
    }
  }

  return quantity;
};

export const _compareCartAndAddProductAdditions = ({
  productAdditions,
  products,
  cart,
  getVariantQuantityFromCart,
  getVariantQuantity,
  balanceProductAddtions,
  widgetID,
}) => {
  const balance = [];
  const existing = {};
  products.map(product => {
    return product.variants.map(variant => {
      const addedQuantity = getVariantQuantity(productAdditions, variant.id);
      const { id, title: variant_title } = variant;
      const key = id.toString();
      if (!existing[key]) {
        existing[key] = {
          quantity: addedQuantity,
          product_id: product.id,
          variant_title,
        };
      }
      return existing;
    });
  });

  for (const [key, value] of Object.entries(existing)) {
    const variant_id = parseInt(key, 10);
    const cartQuantity = getVariantQuantityFromCart(cart, variant_id);
    const { product_id, variant_title, quantity } = value;
    if (cartQuantity !== quantity) {
      balance.push({
        product_id,
        variant_id,
        quantity: cartQuantity - quantity,
        variant_title,
      });
    }
  }

  if (balance.length > 0) {
    balanceProductAddtions({ balance, widgetID });
  }
};

export const _getVariantQuantityFromCart = (cart, variantid) => {
  let quantity = 0;
  for (let i = 0; i < cart.length; i++) {
    if (cart[i].sp_variant_id === variantid) {
      quantity += cart[i].quantity;
    }
  }

  return quantity;
};

export const _getTotalQuantity = productAdditions => {
  return productAdditions.reduce((total, current) => {
    return total + current.quantity;
  }, 0);
};

export const _isMaximumProductsAdded = ({
  idx,
  getProductAddtionsByProductIndex,
  getTotalQuantity,
  discountQuantity,
  isDiscountQuantityRestricted,
  isNumberOfOfferedProductsRestricted,
  isCurrProductSelectedInRestrictedOfferedProductsResult,
  primary,
}) => {
  const additions = getProductAddtionsByProductIndex(idx);
  let quantity = getTotalQuantity(additions);
  if (
    _isPrimaryAndOfferedSame({
      productAdditions: additions,
      primary,
    })
  ) {
    quantity -= 1;
  }

  if (isNumberOfOfferedProductsRestricted) {
    if (isCurrProductSelectedInRestrictedOfferedProductsResult === idx) {
      return isDiscountQuantityRestricted && quantity >= discountQuantity;
    }
    return false;
  }

  return isDiscountQuantityRestricted && quantity >= discountQuantity;
};

export const _isOfferedProductsRestrictedAndAdded = ({
  productAdditions,
  getTotalQuantity,
  isNumberOfOfferedProductsRestricted,
  primary,
}) => {
  let totalQuantity = getTotalQuantity(productAdditions);

  if (
    _isPrimaryAndOfferedSame({
      productAdditions,
      primary,
    })
  ) {
    totalQuantity -= 1;
  }

  return isNumberOfOfferedProductsRestricted && totalQuantity >= 1;
};

export const _isCurrProductSelectedInRestrictedOfferedProducts = ({
  // idx,
  cart,
  products,
  getProductAddtionsByProductIndex,
  getTotalQuantity,
  isNumberOfOfferedProductsRestricted,
  primary,
}) => {
  for (let i = 0; i < cart.length; i += 1) {
    const { sp_product_id, sp_variant_id } = cart[i];

    for (let j = 0; j < products.length; j += 1) {
      const { id, variants } = products[j];

      const variantIDs = variants.reduce(
        (items, item) => items.concat(item.id),
        [],
      );

      if (sp_product_id === id && variantIDs.includes(sp_variant_id)) {
        // firstOfferedProductIndex = i;
        const additions = getProductAddtionsByProductIndex(j);
        let quantity = getTotalQuantity(additions);
        if (
          _isPrimaryAndOfferedSame({
            productAdditions: additions,
            primary,
          })
        ) {
          quantity -= 1;
        }

        if (isNumberOfOfferedProductsRestricted && quantity >= 1) return j;
      }
    }
  }

  for (let i = 0; i < products.length; i += 1) {
    const additions = getProductAddtionsByProductIndex(i);
    let quantity = getTotalQuantity(additions);

    if (
      _isPrimaryAndOfferedSame({
        productAdditions: additions,
        primary,
      })
    ) {
      quantity -= 1;
    }

    if (isNumberOfOfferedProductsRestricted && quantity >= 1) return i;
  }
  return -1;
};

export const _getAddedVariantTitleFromCart = ({
  idx,
  cart,
  products,
  primary,
  productAdditions,
}) => {
  const reduceQuantity = _isPrimaryAndOfferedSame({
    productAdditions,
    primary,
  });

  const { sp_variant_id } = primary;

  const variantsToSearch = cart.reduce((items, item) => {
    if (item.sp_product_id === products[idx].id) {
      let quantity = item.quantity;
      if (item.sp_variant_id === sp_variant_id && reduceQuantity) {
        quantity -= 1;
      }
      if (quantity > 0) {
        return items.concat(item.sp_variant_id);
      }
      return items;
    }
    return items;
  }, []);

  if (variantsToSearch.length > 0) {
    const variant = products[idx].variants.find(ele =>
      variantsToSearch.includes(ele.id),
    );

    if (variant) {
      return variant.title;
    }
  }
  return '';
};

export const _getProductIDFromVariantID = (products, variantID) => {
  for (let i = 0; i < products.length; i++) {
    for (let j = 0; j < products[i].variants.length; j++) {
      if (products[i].variants[j].id === variantID) {
        return products[i].id;
      }
    }
  }
  return 0;
};

export const _getProductFromVariantID = (products, variantID) => {
  for (let i = 0; i < products.length; i++) {
    for (let j = 0; j < products[i].variants.length; j++) {
      if (products[i].variants[j].id === variantID) {
        return products[i];
      }
    }
  }
  return {};
};

// events triggered from the product component
export const _productEvent = ({ eventData, primary, products, sendEvent }) => {
  const { name, action, variables } = eventData;
  sendEvent({
    name,
    action,
    primary,
    added: [],
    offered: products,
    variables,
  });
};

export const _getAddedVariantsToDisplay = ({ productAdditions, primary }) => {
  const allVariantsMap = {};
  const filteredVariantsMap = {};

  const reduceQuantity = _isPrimaryAndOfferedSame({
    productAdditions,
    primary,
  });

  const { sp_variant_id } = primary;
  let primaryVariantTitle = '';
  for (let i = 0; i < productAdditions.length; i++) {
    if (reduceQuantity && productAdditions[i].variant_id === sp_variant_id) {
      primaryVariantTitle = productAdditions[i].variant_title;
    }

    if (allVariantsMap[productAdditions[i].variant_title]) {
      allVariantsMap[productAdditions[i].variant_title] +=
        productAdditions[i].quantity;
    } else {
      allVariantsMap[productAdditions[i].variant_title] =
        productAdditions[i].quantity;
    }
  }

  for (const [key, value] of Object.entries(allVariantsMap)) {
    let quantity = value;
    if (reduceQuantity && primaryVariantTitle === key) {
      quantity = quantity - 1;
    }

    if (quantity > 0) {
      filteredVariantsMap[key] = quantity;
    }
  }
  return filteredVariantsMap;
};

export const _isPrimaryAndOfferedSame = ({ productAdditions, primary }) => {
  const { sp_variant_id } = primary;

  for (let i = 0; i < productAdditions.length; i += 1) {
    if (productAdditions[i].variant_id === sp_variant_id) {
      return true;
    }
  }
  return false;
};
